export default {
    sort: 'Сортировка',
    filter: 'Фильтр',
    detail_search: 'Подробный поиск',
    detail: 'Деталь',
    price_missmatch: 'Цена от должна быть меньше цены до',
    fields: {
        term: {
            label: 'Поисковый запрос',
            placeholder: 'Введите поисковый запрос',
        },
        include_description: {
            label: 'Включить описание в поиск',
        },
        city: {
            label: 'Город',
            placeholder: 'Выберите',
        },
        currency: {
            label: 'Валюта',
        },
        category: {
            label: 'Категория',
            placeholder: 'Выберите',
        },
        subcategory: {
            label: 'Подкатегория',
            placeholder: 'Выберите',
        },
        price_from: {
            label: 'Цена от',
            placeholder: 'Введите',
        },
        price_to: {
            label: 'Цена до',
            placeholder: 'Введите',
        },
    },
    sort_options: {
        sort: 'Сортировать',
        createdAt_ASC: 'Дата по возрастанию',
        createdAt_DESC: 'Дата по убыванию',
        distance_ASC: 'Расстояние - рядом',
        priceRSD_ASC: 'Цена по возрастанию',
        priceRSD_DESC: 'Цена по убыванию',
        averageRating_ASC: 'Рейтинг по возрастанию',
        averageRating_DESC: 'Рейтинг по убыванию',
    },
}
